import { useScope } from "~/hooks/useScope";
import { PlatformPoliciesAddDetailPage } from "~/pages/platform/policies-add/PlatformPoliciesAddDetailPage";

export function PlatformPoliciesAddDetailEntryPage() {
  const { regionScope } = useScope();
  return regionScope ? (
    <PlatformPoliciesAddDetailPage scope={regionScope} />
  ) : undefined;
}
